import { renderValueSafeInline } from "./valueFormat";

const normalizeBatteryCurrent = (value) => {
  if (typeof value === "number") {
    return value < -2000 ? "-" : value;
  }

  if (typeof value === "string") {
    const parsed = parseFloat(value.replace(",", "."));
    if (!isNaN(parsed)) {
      return parsed < -2000 ? "-" : parsed;
    }
  }

  return value ?? "-";
};

const parseLegacyBatteryArray = (values) => {
  if (!Array.isArray(values) || values.length < 45) return values;

  return [
    {
      V: values[30] / 10,
      A: (values[31] - 30000) / 10,
      SOC: values[32] / 10,
      MCT: values[33],
      LIFE: values[34],
    },
    {
      V: values[35] / 10,
      A: (values[36] - 30000) / 10,
      SOC: values[37] / 10,
      MCT: values[38],
      LIFE: values[39],
    },
    {
      V: values[40] / 10,
      A: (values[41] - 30000) / 10,
      SOC: values[42] / 10,
      MCT: values[43],
      LIFE: values[44],
    },
  ];
};

const isBatteryPackObject = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  return Object.keys(value).some((key) => /^bat\d+$/i.test(key));
};

const normalizeBatteryEntries = (batt) => {
  if (Array.isArray(batt)) return parseLegacyBatteryArray(batt);

  if (batt && typeof batt === "object") {
    if (Array.isArray(batt.data)) return parseLegacyBatteryArray(batt.data);

    if (isBatteryPackObject(batt)) {
      return Object.entries(batt)
        .filter(([key, value]) => /^bat\d+$/i.test(key) && value)
        .sort(([a], [b]) => {
          const aNo = Number(a.replace(/\D/g, ""));
          const bNo = Number(b.replace(/\D/g, ""));
          return aNo - bNo;
        })
        .map(([, value]) => value);
    }

    return [batt];
  }

  return [batt];
};

export const renderBatteryCompact = (batt) => {
  if (!batt) return "-";

  const arr = normalizeBatteryEntries(batt);
  if (arr.length === 0) return "-";

  return (
    <div style={{ fontSize: 12 }}>
      {arr.map((entry, idx) => {
        if (entry === null || entry === undefined) {
          return <div key={idx}>-</div>;
        }

        if (typeof entry === "object" && !Array.isArray(entry)) {
          const V = entry.V ?? entry.v ?? entry.Voltage ?? "-";
          const A = normalizeBatteryCurrent(
            entry.A ?? entry.a ?? entry.Current ?? "-"
          );
          const SOC = entry.SOC ?? entry.soc ?? "-";
          const MCT = entry.MCT ?? entry.mct ?? null;
          const LIFE = entry.LIFE ?? entry.life ?? null;
          const details = [
            MCT !== null && MCT !== undefined ? `MCT: ${MCT}C` : null,
            LIFE !== null && LIFE !== undefined ? `LIFE: ${LIFE}` : null,
          ].filter(Boolean);

          return (
            <div key={idx}>
              {V !== "-" && A !== "-" && SOC !== "-" ? (
                <>
                  <strong>{idx + 1}.</strong> {V}V A: {A}A SOC: {SOC}%
                  {details.length ? ` ${details.join(" ")}` : ""}
                </>
              ) : (
                <>
                  <strong>{idx + 1}.</strong> Batterikommunikasjonsfeil...
                </>
              )}
            </div>
          );
        }

        return (
          <div key={idx}>
            <strong>{idx + 1}.</strong> {renderValueSafeInline(entry)}
          </div>
        );
      })}
    </div>
  );
};
